import { createContext, useContext, useState } from "react";

interface LazoAIChatContextType {
  scrollToMessageExternalId: string | null;
  setScrollToMessageExternalId: React.Dispatch<React.SetStateAction<string | null>>;
  matchingMessageExternalIds: string[] | null;
  setMatchingMessageExternalIds: React.Dispatch<React.SetStateAction<string[] | null>>;
}

const LazoAIChatContext = createContext<LazoAIChatContextType | undefined>(undefined);

export function LazoAIChatProvider({ children }: React.PropsWithChildren) {
  const [scrollToMessageExternalId, setScrollToMessageExternalId] = useState<string | null>(null);
  const [matchingMessageExternalIds, setMatchingMessageExternalIds] = useState<string[] | null>(null);

  const value: LazoAIChatContextType = {
    scrollToMessageExternalId,
    setScrollToMessageExternalId,
    matchingMessageExternalIds,
    setMatchingMessageExternalIds,
  };

  return <LazoAIChatContext.Provider value={value}>{children}</LazoAIChatContext.Provider>;
}

export function useLazoAIChat(): LazoAIChatContextType {
  const context = useContext(LazoAIChatContext);

  if (!context) {
    return {
      scrollToMessageExternalId: null,
      setScrollToMessageExternalId: () => null,
      matchingMessageExternalIds: null,
      setMatchingMessageExternalIds: () => null,
    };
  }
  return context!;
}
